<template>
  <div class="machines-show-matrix container-fluid">
    <h2 class="page-heading">Матрица {{matrix | get('name')}}</h2>

    <transition name="fade">
      <div class="row">
        <div class="col-md-4">
          <div class="card mb-4">
            <div class="card-header d-flex align-items-center">
              <h3 class="mb-0"><span class="text-caps">Матрица</span></h3>
              <button class="btn btn-sm btn-outline-primary ml-auto" @click="openModal" v-if="$root.checkPermission('web_ta_matrix_edit')">Выбрать матрицу</button>
            </div>
            <div class="card-body" v-if="matrix">
              <table class="table-sm m-0 px-0">
                <thead>
                <tr>
                  <th style="width: 3em;" class="text-right">№</th>
                  <th>Продукт</th>
                  <!--<th>Цена</th>-->
                </tr>
                </thead>
                <tr v-for="(product, index) in matrix.products">
                  <td class="text-right">{{matrix | get(`product_numbers[${index}]`, index+1)}}</td>
                  <td v-if="product.product">
                    <router-link
                      :to="`/settings/recipes/products/${product.product_id}`"
                      class="text-dark"
                    >{{product.product.name}}</router-link>
                  </td>
                  <td v-else>
                    <small><samp
                      class="text-muted"
                      data-title="Некорректная ссылка"
                      data-toggle="tooltip"
                      data-placement="right"
                    >
                      {{product.product_id}}
                    </samp></small>
                  </td>
                  <!--<td>{{product.cost}} Р.</td>-->
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="col-md">
          <div class="card mb-4">
            <div class="card-header d-flex align-items-center">
              <h3 class="mb-0"><span class="text-caps">Остатки ингредиентов</span></h3>
              <btn-action class="btn btn-sm btn-outline-primary ml-auto" @click="fillIngredients">Заполнить все</btn-action>
              <router-link tag="button" to="/admin/models/" class="btn btn-sm btn-outline-primary ml-2 ">Максимальная загрузка</router-link>
            </div>

            <div class="card-body">
              <table class="table-sm m-0 px-0 w-100">
                <thead>
                <tr>
                  <th>Ингредиент</th>
                  <th class="text-right">Остаток</th>
                  <th class="text-right" style="width: 80px;"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="ingredients" v-for="ingredient in ingredients">
                  <td :class="{'text-danger': ingredient.remainder < 0.01}">{{ ingredient.component.name }}</td>
                  <td>
                    <div class="media align-items-center justify-content-end">
                      <small>{{ingredient.remainder | remainder}} / {{ingredient.full}} {{ingredient.component.measure}}</small>
                      <progress-bar
                        :value="ingredient.remainder | remainder"
                        :max="parseInt(ingredient.full)"
                        :threshold="ingredient.critical"
                        :state="ingredient.remainder > ingredient.critical ? 'success' : 'danger'"
                        class="ml-3"
                        style="min-width: 100px; width: 10vw;"
                      />
                    </div>
                  </td>
                  <td class="" style="width: 80px;"><btn-action class="btn btn-sm btn-outline-primary ml-auto" @click="fillOnceIngredient(ingredient)">Заполнить</btn-action></td>
                </tr>
                </tbody>
              </table>
            </div>
            <!--<div class="card-body">
              <button v-if="$root.checkPermission('admin_access')" @click="addRequest" class="btn btn-primary">Добавить в заявку на ингредиенты</button>
            </div>-->
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import find from 'lodash/find'
  import map from 'lodash/map'
  import api from '@/api'
  import matrixModal from '../../../components/machines/modals/matrix-modal.vue'
  import fillIngredientModal from '../../../components/machines/modals/matrix-filling-ingredient.vue'
  import BtnAction from '../../../components/btn-action'

  export default {
    components: {BtnAction},
    props: {
      id: {required: true},
      machine: {type: Object},
    },
    data () {
      return {
        ingredientsForRequest: null,
      }
    },
    computed: {
      matrix () {
        return this.machine.matrix
      },
      ingredients () {
        return this.machine.critical_remainders
      },
    },
    methods: {
      addRequest () {
        api.post('orders/ingredients', {
          request: map(this.ingredientsForRequest, (current) => {
            return {
              amount: current.need,
              component_id: current.component.id,
            }
          }),
        })
      },
      updateIngredientsForRequest () {
        api.post('orders/need', {
          machines: [this.id],
        }).then(({data}) => {
          this.ingredientsForRequest = data.data
        })
      },
      openModal () {
        this.$root.showModal(matrixModal, {machine: this.machine})
          .then((data) => {
            this.$emit('update:machine', Object.assign(this.machine, data))
          })
      },
      fillOnceIngredient (ingredient) {
        this.$root.showModal(fillIngredientModal, {machine: this.machine, ingredient: ingredient})
          .then((data) => {
            this.$emit('update:machine', Object.assign(this.machine, data))
          })


        // if (window.confirm(`Заполнить ингредиент: ${ingredient.component.name} ?`)) {
        //   let data = {
        //     component_id: ingredient.component_id,
        //     full: ingredient.full,
        //     product_number: ingredient.product_number
        //   }
        //   return api.post(`machines/${this.machine.id}/fillOnceIngredient`, data)
        //     .then(({data}) => {
        //       this.$emit('update:machine', Object.assign(this.machine, {critical_remainders: data.critical_remainders}))
        //     })
        // }
      },
      fillIngredients () {
        if (window.confirm('Заполнить ингредиенты?')) {
          return api.post(`machines/${this.machine.id}/fill`)
            .then(({data}) => {
              this.$emit('update:machine', Object.assign(this.machine, {critical_remainders: data.critical_remainders}))
            })
        }
      },
    },
    mounted () {
      //  this.updateIngredientsForRequest()
    },
  }
</script>

<style lang="scss">
  @import "boot";

  .machines-show-matrix {
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/machines/_id/matrix.vue